import { Link } from 'react-router-dom';
import { Play, Sparkles } from 'lucide-react';

const BG_IMG = 'https://customer-assets.emergentagent.com/job_home-rituals/artifacts/sub4vd5m_det.pavimenti_gelsomino.webp';
const BOTTLE_CUTOUT = '/gelsomino-cutout.png';

export default function ProductVideoShowcase() {
  return (
    <section data-testid="product-video-showcase" className="py-16 md:py-24 bg-essenya-bg">
      <div className="container-essenya">
        <div className="relative rounded-[2.5rem] overflow-hidden bg-essenya-ink min-h-[520px] md:min-h-[640px]">
          {/* Background: full product photo with subtle blur + gray gradient */}
          <img
            data-testid="showcase-bg"
            src={BG_IMG}
            alt=""
            className="absolute inset-0 w-full h-full object-cover scale-110 blur-[3px] opacity-80"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/30" />

          <div className="relative grid grid-cols-[1.5fr_1fr] md:grid-cols-2 items-center gap-4 md:gap-8 p-5 md:p-16 min-h-[460px] md:min-h-[640px]">
            <div className="text-white space-y-3 md:space-y-5 z-10">
              <div className="inline-flex items-center gap-2 backdrop-blur-md bg-white/15 border border-white/25 text-white text-[10px] md:text-xs tracking-[0.15em] md:tracking-[0.2em] uppercase rounded-full px-3 py-1.5 md:px-4 md:py-2">
                <Sparkles size={13} strokeWidth={1.5} /> Kit ESSENYA · Offerta lancio
              </div>
              <h2 className="font-display text-2xl md:text-6xl leading-[1.1] md:leading-[1.05] font-medium">
                Una casa che profuma di pulito.<br/>
                <span className="text-essenya-champagne">Tutta in un kit.</span>
              </h2>
              <p className="text-white/85 text-sm md:text-lg max-w-md">
                Lavapavimenti + Sgrassatore + Bonus profumazione. Risparmia con il kit completo ESSENYA, fragranza a tua scelta.
              </p>
              <div className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-2xl p-4 md:p-6 flex flex-col items-start md:flex-row md:items-center gap-3 md:gap-5 mt-3 md:mt-4">
                <div>
                  <p className="text-white/60 text-[10px] md:text-xs tracking-[0.2em] uppercase mb-1">Prezzo kit</p>
                  <p className="font-display text-3xl md:text-5xl">20,99€</p>
                  <p className="text-white/60 text-[10px] md:text-xs mt-1">Spedizione gratuita inclusa</p>
                </div>
                <Link to="/bundle" data-testid="showcase-cta" className="bg-white text-essenya-ink rounded-full px-5 py-3 md:px-6 md:py-4 text-sm md:text-base font-medium hover:bg-essenya-champagne transition whitespace-nowrap">
                  Acquista il kit
                </Link>
              </div>
            </div>

            <div className="relative flex items-center justify-center z-10">
              <div className="absolute -inset-3 md:-inset-8 bg-white/10 backdrop-blur-2xl rounded-[2rem] md:rounded-[3rem] border border-white/15" />
              <img src={BOTTLE_CUTOUT} alt="Kit Essenya" className="relative max-h-[220px] md:max-h-[480px] w-auto object-contain drop-shadow-2xl" />
              <div className="absolute top-4 md:top-8 right-0 backdrop-blur-md bg-white/15 border border-white/25 text-white text-[10px] md:text-xs px-2.5 py-1 md:px-3 md:py-1.5 rounded-full flex items-center gap-1.5">
                <Play size={12} strokeWidth={2} className="fill-white" /> Made in Italy
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
